import _ from 'lodash'
import { useEffect, useState } from 'react'

const handleMessageRaw = function (setKeys: (value: string) => void) {
  return function handleMessage(msg: MessageEvent<string>) {
    console.info('[Received from scanner]', msg.lastEventId, msg)
    setKeys(msg.data)
  }
}

export const useScanner = () => {
  const [keys, setKeys] = useState<string>('')

  useEffect(() => {
    console.info('[Registering keyboard scanner]')
    const throttledHandleMessage = _.throttle(handleMessageRaw(setKeys), 1000)
    window.addEventListener('message', throttledHandleMessage)

    return function () {
      console.info('[Unregister keyboard scanner]')
      window.removeEventListener('message', throttledHandleMessage)
    }
  }, [setKeys])

  return {
    keys,
    getScan: () => {
      setKeys(() => '')
      return keys
    },
    clearKeys: () => {
      setKeys('')
    }
  }
}

export const useScannerReader = (
  onScan: (value: string) => (() => void) | void
) => {
  const { keys, getScan } = useScanner()

  useEffect(() => {
    const value = getScan()
    if (value) {
      const clear = onScan(value)
      return clear
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys, getScan])
}
